/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const todoListSlice = createSlice({
    name: 'todoList',
    initialState: initialState,
    reducers: {
        setTodoList: (state, action) => {
            return action.payload;
        },

        addTodoForm: (state, action) => {
            const updatedTodos = action.payload;

            // 1. Replace the item to be updated in the existing state.
            const updatedList = state.map((item) => {
                const found = updatedTodos.find((newItem) => newItem.id === item.id);
                return found ? found : item;
            });
            // 2. Add item if it doesn't already exist in the state.
            const newItems = updatedTodos.filter((newItem) => {
                return !state.some((item) => item.id === newItem.id);
            });
            // 3. Merge and return (ensuring immutability).
            return [...updatedList, ...newItems];
        },

        setUpdateTodo: (state, action) => {
            const updatedTodos = action.payload;

            // 1. Replace the item to be updated in the existing state.
            const updatedList = state.map((item) => {
                const found = updatedTodos.find((newItem) => newItem.id === item.id);
                return found ? found : item;
            });
            // 2. Add item if it doesn't already exist in the state.
            const newItems = updatedTodos.filter((newItem) => {
                return !state.some((item) => item.id === newItem.id);
            });
            // 3. Merge and return (ensuring immutability).
            return [...updatedList, ...newItems];
        },

        setDeleteTodo: (state, action) => {
            const filterIdsToDelete = action.payload; // e.g.: [1, 5, 12]
            return state.filter((item) => {
                // Return false to remove item if item.id is included in the deletion list
                return !filterIdsToDelete.includes(item.id);
            });
        },
    },
});

export const { setTodoList, addTodoForm, setUpdateTodo, setDeleteTodo } = todoListSlice.actions;
export default todoListSlice.reducer;
